{
  "reminder": {
    "create_reminder": "Créer un rappel",
    "reminder": "Rappel",
    "no_reminder_for_list": "Aucun rappel pour la liste actuelle",
    "send_to": "Envoyer à",
    "actions": "Actions",
    "dismiss": "Ignorer",
    "dismiss_confirm_title": "Êtes-vous sûr de vouloir ignorer le rappel ?",
    "dismiss_confirm_content": "Cliquez sur confirmer pour ignorer le rappel.",
    "remove_reminder": "Supprimer le rappel",
    "remove_confirm_title": "Êtes-vous sûr de vouloir supprimer ce rappel ?",
    "remove_confirm_content": "Cliquez sur confirmer pour supprimer le rappel.",
    "create_reminder_modal": "Créer un rappel",
    "update_reminder_modal": "Mettre à jour le rappel",
    "send_a": "Envoyer un",
    "reminder_text": "rappel",
    "days": "jours",
    "to": "à",
    "time_preposition": "Préposition temporelle",
    "select_date_field": "Sélectionner le champ de date",
    "subject": "Sujet",
    "validation_subject_required": "Veuillez ajouter un sujet",
    "validation_days_required": "Veuillez ajouter les jours de rappel",
    "validation_date_property_required": "Veuillez sélectionner une propriété de date",
    "validation_employees_required": "Veuillez sélectionner au moins 1 employé",
    "update_reminder_aria": "mettre à jour le rappel"
  }
}
